module.exports = __webpack_public_path__ + "img/faq3.3116b855.svg";